import { useContext, useEffect, useRef, useState } from "react"
import { isStickyContext } from "../../contexts/isSticky";
import { isMobileContext } from "../../contexts/isMobileContext";
const NavTabsWithCommercialServices = ({ navlist }) => {
	const { isSticky } = useContext(isStickyContext)
	const { isMobile } = useContext(isMobileContext);
	const [activeId, setActiveId] = useState(false)
	const [activeRef, setActiveRef] = useState(false)
	const overview = useRef();
	const facilities = useRef();
	const amenities = useRef()
	const landmarks = useRef()
	const similarProjects = useRef()
	const masterplan = useRef()
	const enquire = useRef()
	const commercialServices = useRef();
	const [navRefs,setNavRefs] = useState([
		overview,
		masterplan,
		amenities,
		facilities,
		landmarks,
		commercialServices,
		similarProjects,
		enquire
	])
	const [scroll, setScroll] = useState(false)
	const executeScroll = (path) => {
		path.current.scrollIntoView({ behavior: "smooth" })
	}
	const executeScrollX = (tab) => {
		tab?.current?.scrollIntoView({ behavior: "smooth", block: 'nearest', inline: 'center' })
	}
	useEffect(() => {
		window.addEventListener("scroll", (e) => {
			e.preventDefault(),
				setScroll(window?.scrollY == 0)
		},
			// {passive: true}
		)
		return window.removeEventListener("scroll", setScroll)
	}, [])
	useEffect(() => {
		navlist.map((link) => {
			window.addEventListener("scroll", (e) => {
				e.preventDefault()
				window.scrollY + 100 >= link.path?.current?.offsetTop &&
					(
						setActiveId(link.path),
						setActiveRef(link.id)
					)
			},
				//  {passive: true}
			)
		})
		return window.removeEventListener("scroll", setScroll)
	}, [navlist])
	useEffect(() => {
		scroll && setActiveId(false)
	}, [scroll])
	useEffect(() => {
		isMobile &&
			executeScrollX(
				navRefs[activeRef - 1])
	}, [activeRef, isMobile, navRefs])
	return (
		<>
			<div className={`nav-tabs-container bold ${isSticky ? "postion" : ""}`}>
				<ul>
					{navlist?.map((item, index) => (
						<li
							id={index}
							ref={navRefs[index]}
							key={index}
							onClick={() => {
								setActiveId(item.path)
								executeScroll(item.path)
							}}
							className={activeId == item.path ? "active" : ""}
						>
							{item.text}
						</li>
					))}
				</ul>
			</div>
		</>
	)
}

export default NavTabsWithCommercialServices